import { useEffect } from 'react';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { ToastContainer, toast } from 'react-toastify';
import { feathersClient } from './client';
import { useAppDispatch } from './store';
import { logoutUserFromLoacal } from './store/auth/authSlice';
import { ConfirmProvider } from 'material-ui-confirm';
import CloseIcon from '@mui/icons-material/Close';
import { Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { setStatus as setNotifcationStatus } from './store/notification/notificationSlice';
import { useMediaBaseUrl } from './hooks/useMediaBaseUrl';
import { config } from './utils/utils';
import { clearStaleAuthSession } from './utils/clearStaleAuthSession';

const App = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useMediaBaseUrl();

  useEffect(() => {
    const token = localStorage.getItem(config.AUTH_KEY);
    if (!token) {
      return;
    }

    feathersClient.reAuthenticate().catch(() => {
      dispatch(logoutUserFromLoacal());
      clearStaleAuthSession();
    });
  }, [dispatch]);

  useEffect(() => {
    navigator?.serviceWorker?.addEventListener('message', (event) => {
      try {
        const audio = new Audio('/new-sound.wav');
        audio.play();
      } catch (error) {
        console.log('Audio play error:', error);
      }
      const { messageType, data } = event?.data;
      if (messageType === 'notification-clicked') {
        if (data?.title === 'New Order Placed') {
          dispatch(setNotifcationStatus({ status: 'idle' }));
          // dispatch(
          //   findNotification({
          //     isRead: false,
          //     isExport: true,
          //     moduleType: NotificationModuleType.order,
          //     receiverUserId: id,
          //   })
          // );
          toast.info(
            <div>
              <h5>{data?.title}</h5>
              <span>{data?.message}</span>
            </div>,
            { autoClose: 5000 }
          );
          navigate(`/order`);
        }
      }
    });
  }, []);

  useEffect(() => {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SOUND_NOTIFICATION') {
        const audio = new Audio('/new-sound.wav');
        audio.play().catch((error) => {
          console.error('Error playing sound:', error);
        });
      }
    });
  }, []);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <ConfirmProvider
        defaultOptions={{
          confirmationButtonProps: {
            variant: 'contained',
            sx: { marginBottom: '8px', marginRight: '8px' },
          },
          confirmationText: 'Yes',
          cancellationButtonProps: {
            sx: { position: 'absolute', top: '8px', right: '0' },
          },
          cancellationText: <CloseIcon sx={{ color: '#9f9f9f' }}></CloseIcon>,
        }}
      >
        <Router />
      </ConfirmProvider>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        theme='colored'
        rtl={false}
        pauseOnFocusLoss
        draggable
        transition={Slide}
        pauseOnHover
      />
    </ThemeConfig>
  );
};
export default App;
